import { Box, Button, Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useGetAllAssetsQuery } from '../../../../app/Slices/SevenDayApiSlice';
import { OwnerProfile } from '../../../types/owner';
import { PublishedExperience } from '../../../types/experience';
import ExperienceCard from '../../Experiences/ExperienceCard';

const OwnerProfileListings = ({ owner }: { owner: OwnerProfile }) => {
    const { data: listings } = useGetAllAssetsQuery({
        url: '/modules',
        owner: owner.id,
    });

    const [viewAll, setViewAll] = useState(false);

    const displayedListings =
        (viewAll ? listings : listings?.slice(0, 3)) ?? [];

    if (displayedListings.length === 0) return null;

    return (
        <section aria-labelledby='owner-profile-listings-heading'>
            <Typography
                id='owner-profile-listings-heading'
                variant='h2'
                sx={{ pb: 2 }}
            >
                Listings
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Grid container spacing={3}>
                    {displayedListings.map((listing: PublishedExperience) => (
                        <Grid key={listing.id} item xs={12} sm={6} md={4}>
                            <ExperienceCard
                                experience={listing}
                                visitType={listing.visitType}
                            />
                        </Grid>
                    ))}
                </Grid>
                {listings && listings.length > 3 && (
                    <Button
                        variant='text'
                        color='primary'
                        onClick={() => setViewAll(!viewAll)}
                        sx={{ ml: 'auto' }}
                    >
                        Show {viewAll ? 'less' : 'more'} listings
                    </Button>
                )}
            </Box>
        </section>
    );
};

export default OwnerProfileListings;
